import joint from 'jointjs';

const nativeDOMParserClass = window.DOMParser;
const parserCache = {};
let isDeserializingInProgress = false;


/**
 * When deserializing a bigger graph, joinjs can call parsFromString() thousands of times,
 * with only 4 or 5 different svg strings.
 * To improve deserializiation times, let's use a wrapper parser that caches the nodes for already-parsed svg strings
 */
class CachingDOMParser {

  constructor() {
    this.nativeDOMParser = new nativeDOMParserClass();
  }

  parseFromString(str, type) {
    if (isDeserializingInProgress) {
      return this.cachedParseFromString(str, type);
    } else {
      return this.nativeDOMParser.parseFromString(str, type);
    }
  }

  cachedParseFromString(str, type) {
    if (!parserCache[str]) {
      parserCache[str] = this.nativeDOMParser.parseFromString(str, type);
    }
    try {
      return parserCache[str].cloneNode(true);
    } catch (e) {
      // Ionic's DOM polyfill crashes on IE11 :(
      return this.nativeDOMParser.parseFromString(str, type);
    }
    
  }

}


export class JointjsOptimisationsService {
  constructor($http, $q, MetricsFactory, $translate) {
    this._$http = $http;
    this._$q = $q;
    this.MetricsFactory = MetricsFactory;
    this.$translate = $translate;
  }


  init() {
    if (window.DOMParser === nativeDOMParserClass) {

      // Override native DOMParser with custom parser that caches parsed nodes
      window.DOMParser = CachingDOMParser;

      // Negligible perf gain, but as we don't use (nor even display) the links tools, we might as well skip rendering them
      joint.dia.LinkView.prototype.renderTools = function() { return this };
      joint.dia.LinkView.prototype.updateToolsPosition = function() { return this };
    } else {
      console.error('JointjsOptimisationsService - init(): seems that we are already inited');
    }

  }

  isDeserializingInProgress() {
    return isDeserializingInProgress;
  }

  deserializingStarts() {
    isDeserializingInProgress = true;
    this.startMs = performance.now();
    if (window.skipArrowOrient) {
      joint.dia.LinkView.prototype._translateAndAutoOrientArrows = function() { };
    }
  }

  setNumberOfBoxes(numberOfBoxes) {
    this.numberOfBoxes = numberOfBoxes;
  }

  setNumberOfLinks(numberOfLinks) {
    this.numberOfLinks = numberOfLinks;
  }

  deserializingEnds() {
    isDeserializingInProgress = false;
    const deltaS = (performance.now() - this.startMs) / 1000;
  }

  logCallsToResize() {
    return window.logCallsToResize;
  }
 

  static JointjsOptimisationsFactory($http, $q, MetricsFactory, $translate) {
    return new JointjsOptimisationsService($http, $q, MetricsFactory, $translate);
  }
}

JointjsOptimisationsService.JointjsOptimisationsFactory.$inject = ['$http', '$q', 'MetricsFactory', '$translate'];
